<jhi-alert></jhi-alert>
<jhi-spinner *ngIf="loading"></jhi-spinner>
<div class="col-xl card-pg">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body">
        <div style="justify-content: center;">
          <div class="container">
            <div class="row" style="justify-content: center;"
                 [hidden]="(!listaPagamenti || listaPagamenti.length == 0) && isJsonForm">
              <div class="col-xl-10 col-lg-12">
                <div class="card mb-0 pb-0">
                  <div id="custom-card-body" class="card-body mt-0 mb-0 pt-0 pb-0">
                    <div class="d-flex flex-wrap" style="justify-content:center">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-2">
                        <div class="d-flex" style="justify-content:center" *ngIf="isJsonForm && !pagamentoSingolo">
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.privacy">
                              Privacy
                            </div>
                            <button [disabled]="true" class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 0 ? 'btn-actual-step border-circle' : 'btn-last-step primary-button'">
                              1
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.seleziona">
                              Seleziona
                            </div>
                            <button class="btn rounded-circle btn-primary p-1 "
                                    [ngClass]="curIndex == 1 ? 'btn-actual-step border-circle' : (curIndex == 0 ? 'btn-next-step' : 'btn-last-step primary-button')"
                                    [disabled]="true">2
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.dati">Dati
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 2 ? 'btn-actual-step border-circle' :(curIndex < 3 ? 'btn-next-step' : 'btn-last-step primary-button')"
                                    [disabled]="true">3
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.conferma">
                              Conferma
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 3 ? 'btn-actual-step border-circle' : (curIndex < 3 ? 'btn-next-step' : 'btn-last-step primary-button')"
                                    [disabled]="true">4
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.ricevuta">
                              Ricevuta
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 4 ? 'btn-actual-step border-circle' : 'btn-next-step'"
                                    [disabled]="true">5
                            </button>
                          </div>
                        </div>
                        <div class="d-flex" style="justify-content:center" *ngIf="pagamentoSingolo">
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.privacy">
                              Privacy
                            </div>
                            <button [disabled]="true" class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 0 ? 'btn-actual-step border-circle' : 'btn-last-step primary-button'">
                              1
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.dati">
                              Dati
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 1 ? 'btn-actual-step border-circle' : (curIndex == 0 ? 'btn-next-step border-circle' : 'btn-last-step primary-button')"
                                    [disabled]="true">2
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.conferma">
                              Conferma
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 2 ? 'btn-actual-step border-circle' : (curIndex < 3 ? 'btn-next-step border-circle' : 'btn-last-step primary-button')"
                                    [disabled]="true">3
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.ricevuta">
                              Ricevuta
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 3 ? 'btn-actual-step border-circle' : 'btn-next-step border-circle'"
                                    [disabled]="true">4
                            </button>
                          </div>
                        </div>
                        <div class="d-flex" style="justify-content:center" *ngIf="!isJsonForm">
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.privacy">
                              Privacy
                            </div>
                            <button [disabled]="true" class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 0 ? 'btn-actual-step border-circle' : 'btn-last-step primary-button'">
                              1
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label">
                              Pagamento
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex == 1 ? 'btn-actual-step border-circle' : (curIndex == 0 ? 'btn-next-step' : 'btn-last-step primary-button')"
                                    [disabled]="true">2
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label"
                                 jhiTranslate="pagamenti.paginaPagamento.stepper.ricevuta">
                              Ricevuta
                            </div>
                            <button class="btn rounded-circle btn-primary p-1"
                                    [ngClass]="curIndex === 2 ? 'btn-actual-step border-circle' : 'btn-next-step'"
                                    [disabled]="true">3
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [hidden]="(!listaPagamenti || listaPagamenti.length === 0) && isJsonForm">
            <!-- Accetta privacy -->
            <div [hidden]="curIndex !== 0">
              <h6 class="text-center text-uppercase" jhiTranslate="pagamenti.paginaPagamento.titoloPrivacy">
                INFORMATIVA SULLA PRIVACY
              </h6>
              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <h3 class="card-title h5 ">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-locked"></use>
                        </svg>
                        <span class="link-primary" jhiTranslate="pagamenti.paginaPagamento.titoloPrivacy">Informativa sulla privacy</span>
                      </h3>
                      <div class="card-body">
                        <!-- <div jhiTranslate="pagamenti.paginaPagamento.contenutoPrivacy"> -->
                        <!-- TODO: Se si deve implementare la riga sopra con la traduzione va passata la variabile -->
                        <div>
                          <p>
                            Il Comune di <span
                            *ngIf="configurazioneService.configurazione">{{ configurazioneService.configurazione.nome }}</span>
                            gestisce i dati personali forniti e liberamente comunicati sulla
                            base
                            dell'articolo 13 del Regolamento (UE) 2016/679
                            General data protection regulation (Gdpr) e gli articoli 13 e successive modifiche e
                            integrazione del decreto legislativo (di seguito d.lgs) 267/2000
                            (Testo unico enti locali)
                          </p>
                          <p>Per i dettagli sul trattamento dei dati personali consulta l'informativa sulla privacy</p>
                        </div>
                        <div>
                          <div class="form-check">
                            <input id="checkboxPrivacy" type="checkbox" [(ngModel)]="checkBoxPrivacy">
                            <label for="checkboxPrivacy" class="fw-bold"
                                   jhiTranslate="pagamenti.paginaPagamento.checkboxPrivacy">Ho letto e compreso
                              l'informativa sulla
                              privacy</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!-- Dati pagamento -->
            <div *ngIf="curIndex == 1 && !tributoMsg?.tributo?.flPagamento && !pagamentoSingolo">
              <h6 class="text-center text-uppercase" jhiTranslate="pagamenti.paginaPagamento.datiPagamento.titolo">
                DATI PAGAMENTO
              </h6>
              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <h3 class="card-title h5 ">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-user"></use>
                        </svg>
                        <span class="link-primary"
                              jhiTranslate="pagamenti.paginaPagamento.datiPagamento.informazioniPersonali">Informazioni personali</span>
                      </h3>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-3">
                            <span class="fw-bold"><span jhiTranslate="form.nome">Nome</span>:</span>
                            <span>{{ userData.nome }}</span>
                          </div>
                          <div class="col-lg-3">
                            <span class="fw-bold"><span jhiTranslate="form.cognome">Cognome</span>:</span>
                            <span>{{ userData.cognome }}</span>
                          </div>
                          <div class="col-lg-3">
                            <span class="fw-bold">CF:</span>
                            <span>{{ userData.cf }}</span>
                          </div>
                          <div class="col-lg-3">
                            <span class="fw-bold" jhiTranslate="form.email:">Email:</span>
                            <span>{{ userData.email }}</span>
                          </div>
                        </div>
                        <h3 class="card-title h5 mt-5 ">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                               height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 502.685 502.685"
                               class="icon">
                            <g>
                              <g>
                                <path style="fill:#010002;"
                                      d="M482.797,276.924c4.53-5.824,6.73-13.331,4.724-20.988L428.05,30.521    c-3.451-13.029-16.847-20.837-29.854-17.386L18.184,113.331C5.22,116.761-2.61,130.2,0.798,143.207L60.269,368.6    c3.408,13.007,16.868,20.816,29.876,17.408l134.278-35.419v75.476c0,42.214,69.954,64.303,139.11,64.303    c69.113,0,139.153-22.089,139.153-64.302V311.61C502.685,297.869,495.157,286.307,482.797,276.924z M439.763,199.226l6.212,23.469    l-75.541,19.953l-6.169-23.512L439.763,199.226z M395.931,50.733l11.799,44.695l-118.014,31.148l-11.799-44.695L395.931,50.733z     M342.975,224.744l6.04,22.951c-27.934,1.251-55.113,6.126-76.943,14.452l-4.616-17.429L342.975,224.744z M79.984,319.224    l-6.169-23.426l75.519-19.975l6.212,23.555L79.984,319.224z M170.625,270.237l75.476-19.953l5.716,21.506    c-1.834,1.122-3.559,2.286-5.242,3.473l-69.781,18.421L170.625,270.237z M477.491,424.209c0,24.612-50.993,44.544-113.958,44.544    c-62.9,0-113.937-19.953-113.937-44.544v-27.718c0-0.928,0.539-1.769,0.69-2.653c3.602,23.34,52.654,41.847,113.247,41.847    c60.614,0,109.687-18.508,113.268-41.847c0.151,0.884,0.69,1.726,0.69,2.653V424.209z M477.491,369.678    c0,24.591-50.993,44.522-113.958,44.522c-62.9,0-113.937-19.931-113.937-44.522V341.96c0-0.906,0.539-1.769,0.69-2.653    c3.602,23.318,52.654,41.869,113.247,41.869c60.614,0,109.687-18.551,113.268-41.869c0.151,0.884,0.69,1.747,0.69,2.653V369.678z     M363.532,356.11c-62.9,0-113.937-19.931-113.937-44.501c0-24.569,51.036-44.5,113.937-44.5c62.965,0,113.958,19.931,113.958,44.5    C477.491,336.179,426.497,356.11,363.532,356.11z"/>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                            </g>
                          </svg>
                          <span class="link-primary" jhiTranslate="pagamenti.paginaPagamento.datiPagamento.titolo">Dati pagamento</span>
                        </h3>
                        <div class="row">
                          <div class="col-lg-4">
                            <span class="fw-bold">Importo: </span>
                            <span>{{ pagamentoMsg?.pagamento?.importo | currency: 'EUR' }}</span>
                          </div>
                          <div class="col-lg-4">
                            <span class="fw-bold">Causale: </span>
                            <span *ngIf="pagamentoMsg && pagamentoMsg.pagamento?.causale">{{ pagamentoMsg.pagamento?.causale?.descrizione}}</span>
                            <span *ngIf="!pagamentoMsg?.pagamento?.causale" class="text-center">-</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
              </div>
            </div>
            <!-- Seleziona Pagamento da lista -->
            <div
              [hidden]="!isJsonForm || (curIndex != 1 && tributoMsg?.tributo?.flPagamento) || (!tributoMsg?.tributo?.flPagamento && pagamentoSingolo) ">
              <div class="row justify-content-center">
                <h6 class="text-center text-uppercase"
                    jhiTranslate="pagamenti.paginaPagamento.tabellaSelezione.titoloCard">SELEZIONA UN PAGAMENTO</h6>
                <div class="col-xl-10">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <table class="my-2 w-100">
                        <caption class="d-none">Lista pagamenti dovuti</caption>
                        <tr>
                          <th scope="col" class="col-lg-3"
                              jhiTranslate="pagamenti.paginaPagamento.tabellaSelezione.identificatore">Identificatore
                          </th>
                          <th scope="col" class="col-lg-5"
                              jhiTranslate="pagamenti.paginaPagamento.tabellaSelezione.descrizione">Descrizione
                            pagamento
                          </th>
                          <th scope="col" class="col-lg-2"
                              jhiTranslate="pagamenti.paginaPagamento.tabellaSelezione.importo">Importo
                          </th>
                          <th scope="col" class="col-lg-2"
                              jhiTranslate="pagamenti.paginaPagamento.tabellaSelezione.stato">Stato
                          </th>
                        </tr>
                        <tr *ngFor="let pg of listaPagamenti; index as i"
                            [ngClass]="{'border-bottom-global': (i + 1) != listaPagamenti?.length,'border-left-global': pg == pagamentoSelezionato, 'cursor-pointer': pg.stato !== 'PAGAMENTO_AVVIATO'}"
                            (click)="selezionaPagamento(pg)">
                          <td class="col-lg-3 py-2 px-3">
                            <div> {{ pg.idEsterno || ' - ' }}</div>
                          </td>
                          <td class="col-lg-5">
                            <div [title]="pg.descrizione">{{ pg.descrizione || ' - ' }}</div>
                          </td>
                          <td class="col-lg-2">
                            <div>{{ pg.importoDovuto | currency:'EUR' || ' - ' }}</div>
                          </td>
                          <td [class]="'col-lg-2 ' + mapStatiPagamento.get(pg.stato)?.colore">
                            <div
                              class="d-flex flex-row align-items-center min-status">{{ mapStatiPagamento.get(pg.stato)?.testo || ' - ' }}
                              <div *ngIf="pg.stato === 'PAGAMENTO_AVVIATO'"
                                   title="Vai alla lista pagamenti per recuperare questo pagamento">
                                <svg class="icon icon-sm align-top ms-1 cursor-pointer icon-orange"
                                     (click)="vaiAListaPagamenti()">
                                  <use href="./content/svg/sprites.svg#it-warning-circle"></use>
                                </svg>
                              </div>
                            </div>
                          </td>
                          <br *ngIf="windowSize <= 768">
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Dati JsonForm -->
            <div
              [hidden]="(curIndex != 2 && curIndex != 3 && tributoMsg?.tributo?.flPagamento || (pagamentoSingolo && curIndex === 0) || !isJsonForm)">
              <div class="row justify-content-center" *ngIf="curIndex === 3">
                <div class="col-xl-10">
                  <div class="d-flex flex-column">
                    <div class="callout callout-highlight warning custom-callout">
                      <div class="callout-title">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-horn"></use>
                        </svg>
                        <span jhiTranslate="pagamenti.titoloCallout">Attenzione</span></div>
                      <p jhiTranslate="pagamenti.testoCallout" class="p-responsive">Le informazioni che hai fornito
                        hanno valore di dichiarazione. Verifica che siano corrette.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <div class="mb-4" *ngIf="pagamentoSelezionato">
                        <h6 class="text-center">Dettaglio pagamento </h6>
                        <div class="row mt-3">
                          <div class="col-lg-12">
                            <div class="d-flex flex-row">
                              <span class="fw-bold txt-sm">Identificatore: </span>
                              <span class="ms-1 txt-sm">{{ pagamentoSelezionato.idEsterno }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="d-flex flex-row">
                              <span class="fw-bold txt-sm">Descrizione: </span>
                              <span class="ms-1 txt-sm">{{ pagamentoSelezionato.descrizione }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <dmidynamic-form-render></dmidynamic-form-render>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="curIndex === 3" class="row justify-content-center">
                <div class="col-xl-10">
                  <p class="mt-2 text-nb">
                    <svg class="icon icon-xs icon-primary">
                      <use href="./content/svg/sprites.svg#it-info-circle"></use>
                    </svg>
                    <span jhiTranslate="pagamenti.msgProseguiPaga">Per proseguire con il pagamento cliccare su paga, altrimenti tornare indietro e modificare i dati</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- Ricevuta pagamento -->
            <div
              [hidden]="(curIndex !== 4 && tributoMsg?.tributo?.flPagamento) || (!isJsonForm && curIndex !== 2)">
              <h6 class="text-center">
                RIEPILOGO PAGAMENTO
              </h6>
              <div class="row justify-content-center">
                <div class="col-xl-10 mb-5">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <h3 class="card-title h5 ">
                        <svg class="icon icon-sm" xmlns="http://www.w3.org/2000/svg" width="800px" height="800px"
                             viewBox="0 0 24 24" fill="none">
                          <path d="M9 10L12.2581 12.4436C12.6766 12.7574 13.2662 12.6957 13.6107 12.3021L20 5"
                                stroke="#33363F" stroke-width="2" stroke-linecap="round"/>
                          <path
                            d="M21 12C21 13.8805 20.411 15.7137 19.3156 17.2423C18.2203 18.7709 16.6736 19.9179 14.893 20.5224C13.1123 21.1268 11.187 21.1583 9.38744 20.6125C7.58792 20.0666 6.00459 18.9707 4.85982 17.4789C3.71505 15.987 3.06635 14.174 3.00482 12.2945C2.94329 10.415 3.47203 8.56344 4.51677 6.99987C5.56152 5.4363 7.06979 4.23925 8.82975 3.57685C10.5897 2.91444 12.513 2.81996 14.3294 3.30667"
                            stroke="#33363F" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                      </h3>
                      <div class="row">
                        <div class="col-lg-4">
                          <span class="fw-bold" jhiTranslate="pagamenti.paginaPagamento.ricevutaPagamento.pagante">Pagante:</span>
                          <span>{{ userData.cognome }} {{ userData.nome }}</span>
                        </div>
                        <div class="col-lg-4">
                          <span class="fw-bold" jhiTranslate="pagamenti.paginaPagamento.ricevutaPagamento.importo">Importo:</span>
                          <span
                            *ngIf="!isJsonForm && pagamentoMsg && pagamentoMsg.pagamento">{{ pagamentoMsg.pagamento.importo | currency : 'EUR' }}</span>
                          <span
                            *ngIf="isJsonForm && pagamentoSelezionato">{{ pagamentoSelezionato.importoDovuto | currency : 'EUR' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container mb-5">
                  <form class="row" [formGroup]="ratingForm" *ngIf="!feedbackInviato; else nonInviato">
                    <jhi-rating (ratingSelected)="onRatingSelected($event)"></jhi-rating>
                    <div *ngIf="selectedRating > 0 && !inTextAreaPhase" class="question-container mt-5"
                         [ngClass]="{'less-bright': selectedRating <= 3}">
                      <jhi-question *ngIf="choices.length > 0" [question]="questionText" [choices]="choices"
                                    (choiceSelected)="handleChoiceSelected($event)"></jhi-question>
                      <div class="button-container text-end mt-5">
                        <button class="back-button btn btn-primary primary-button" (click)="resetSelection()">Indietro
                        </button>
                        <button class="next-button submit-button btn btn-primary primary-button"
                                (click)="showTextArea()"
                                [disabled]="ratingForm.get('primaRisposta')?.value === null && ratingForm.get('secondaRisposta')?.value === null">
                          Avanti
                        </button>
                      </div>
                    </div>
                    <div *ngIf="inTextAreaPhase" class="question-container mt-5">
                      <div class="textarea-question">
                        <p>Vuoi aggiungere altri dettagli?</p>
                        <textarea class="text-area" maxlength="200" formControlName="note"></textarea>
                      </div>
                      <div class="button-container text-end mt-5">
                        <button class="back-button btn btn-primary primary-button" (click)="backToChoices()">Indietro
                        </button>
                        <button class="submit-button btn btn-primary primary-button" (click)="submitQuestion()">Invia
                        </button>
                      </div>
                    </div>
                  </form>
                  <ng-template #nonInviato>
                    <div class="d-flex justify-content-center mt-3">
                <span class="fw-bold">Feedback inviato
                  <svg class="icon icon-color">
                    <use href="./content/svg/sprites.svg#it-check"></use>
                  </svg>
                </span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <!-- Card di loading -->
          <div *ngIf="(!listaPagamenti || listaPagamenti.length === 0) && loading">
            <div [hidden]="curIndex !== 0">
              <h6 class="text-center text-uppercase" jhiTranslate="pagamenti.caricamentoDati">
                CARICAMENTO DATI
              </h6>
              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <h3 class="card-title h5 ">
                        <div class="d-flex">
                          <div class="progress-spinner progress-spinner-active size-sm mx-2">
                            <span class="visually-hidden">Caricamento...</span>
                          </div>
                          <span class="text-primary"
                                jhiTranslate="pagamenti.caricamentoPagamenti">Caricamento pagamenti</span>
                        </div>
                      </h3>
                      <div class="card-body">
                        <p jhiTranslate="pagamenti.testoCaricamentoPagamenti">Caricamento dei pagamenti in corso... Si
                          prega di attendere.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- Card no pagamenti -->
          <div *ngIf="(!listaPagamenti || listaPagamenti.length === 0) && !loading && isJsonForm">
            <div [hidden]="curIndex !== 0" class="mt-3">
              <h6 class="text-center text-uppercase mb-4" jhiTranslate="pagamenti.titoloPagamentiNonTrovati">
                NESSUN PAGAMENTO TROVATO
              </h6>
              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <div class="card card-teaser rounded shadow">
                    <div class="card-body">
                      <h3 class="card-title h5">
                        <svg class="icon icon-sm icon-primary">
                          <use href="./content/svg/sprites.svg#it-warning-circle"></use>
                        </svg>
                        <span class="link-primary" jhiTranslate="pagamenti.sottotitoloPagamentiNonTrovati">Non ci sono pagamenti da visualizzare</span>
                      </h3>
                      <div class="card-body">
                        <div>
                          <p jhiTranslate="pagamenti.testoCardNoPagamenti" *ngIf="!cdServizio"
                             [translateValues]="{servizio: tributoMsg?.nmTitolo}">Non sono stati trovati pagamenti a tuo
                            nome per il servizio {{ tributoMsg?.nmTitolo }}. <br>
                            Ti invitiamo a controllare nuovamente in seguito per verificare se sono stati aggiunti nuovi
                            pagamenti.
                          </p>
                          <p jhiTranslate="pagamenti.testoCardNoPagamenti" *ngIf="cdServizio"
                             [translateValues]="{servizio: cdServizio}">Non sono stati trovati pagamenti a tuo
                            nome per il servizio {{ cdServizio }}. <br>
                            Ti invitiamo a controllare nuovamente in seguito per verificare se sono stati aggiunti nuovi
                            pagamenti.
                          </p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row" style="justify-content: center;">
        <div class="col-xl-10 col-lg-12">
          <div class="card mb-0 pb-0">
            <div class="card-body mt-4 mb-0 pt-0 pb-0">
              <div class="d-flex" [ngClass]="lastStep ? 'justify-content-end' : 'justify-content-between'">
                <button (click)="goBack()" #btnIndietro class="btn btn-primary primary-button"
                        jhiTranslate="form.indietro" *ngIf="(!loading || !isJsonForm) && !lastStep">
                  Indietro
                </button>
                <button type="button" #btnAvanti
                        *ngIf="(listaPagamenti && listaPagamenti.length > 0) || !isJsonForm"
                        class="btn btn-primary primary-button"
                        (click)="vaiAvanti()"
                        [disabled]="checkValidazioneStep()"
                >{{ txtProcedi }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
